import Pessoa from "model/administracao/cadastro/Pessoa";
import { BaseModel } from "model/BaseModel";
import Endereco from "../endereco/Endereco";

export default class Coleta implements BaseModel {
    id: number;
    codigo = "";
    numero: number;
    dataPrevista: Date|null;
    dataRealizada: Date|null;
    observacao: string;
    observacaoMotorista: string;
    status: string;
    cliente: Pessoa|null;
    endereco: Endereco;

    constructor(
        id: number = 0,
        numero: number = 0,
        dataPrevista: Date|null = null,
        dataRealizada: Date|null = null,
        observacao: string = "",
        observacaoMotorista: string = "",
        status: string = "CRIADA",
        cliente: Pessoa|null = null,
        endereco: Endereco = new Endereco()
    ) {
        this.id = id;
        this.numero = numero;
        this.dataPrevista = dataPrevista;
        this.dataRealizada = dataRealizada;
        this.observacao = observacao;
        this.observacaoMotorista = observacaoMotorista;
        this.status = status;
        this.cliente = cliente;
        this.endereco = endereco;
    }
}